<template>
  <div class="unpack-add">
    <BaseFrame
     :btns="[
      {
        name: 'cancel',
        text: '取消'
      },
      {
        name: 'submit',
        text: '提交',
        type: 'primary'
      },
     ]"
     :breadcrumb="[
      {
        name: 'unpackList',
        title: '商品拆零列表'
      },
      {
        name: 'unpackAdd',
        title: '新建拆零'
      }
     ]"
     @btn-click="onBtnClick"
      >
      <div slot="content">
        <lk-card class="unpack-card">
					<lk-dropdown trigger="custom" :visible="dropdownVisible" @on-click="onDropDownclick" ref="dropdown" class="unpack-dropdown">
						<lk-input
              placeholder="请输入商品名、通用名、助记码、编码"
              @on-change="onInputChange" v-model="nameMix" ref='search'
							@on-blur='inputBlur' @on-focus="onInputChange(true)" clearable class="unpack-input">
						</lk-input>
						<lk-dropdown-menu slot="list" class="searchList" v-if="options.length">
							<lk-dropdown-item disabled name='title'>
								<div class="options">
									<span>药品通用名</span>
									<span>规格</span>
                  <span>单位</span>
									<span>批号</span>
									<span>有效期</span>
									<span>生产厂家</span>
									<span>库存</span>
								</div>
							</lk-dropdown-item>
              <div v-for="(item, index) in options" :key="index" >
                <lk-dropdown-item :name='index'>
                  <div class="options">
                    <span>
                      <lk-tooltip :content='item.approvedDrugName'>
                        <p class="textOver" >{{ item.approvedDrugName }}</p>
                      </lk-tooltip>
                    </span>
                    <span>{{ item.spec }}</span>
                    <span>{{ item.drugMiniPackageUnitString }}</span>
                    <span>{{ item.goodsBatchNumber }}</span>
                    <span>{{ item.goodsExpiryDate }}</span>
                    <span>{{ item.producer }}</span>
                    <span>{{ item.stockNum }}</span>
                  </div>
                </lk-dropdown-item>
              </div>
						</lk-dropdown-menu >
								<lk-dropdown-menu v-if='!options.length' slot="list" class="searchList" >
							<lk-dropdown-item disabled name='noTitle'>
								<div class="noThing">暂无数据</div>
							</lk-dropdown-item>
						</lk-dropdown-menu>
					</lk-dropdown>
          <dtp-table border :columns="columns" :data="tableData" class="unpacktable" v-if='ready'/>
        </lk-card>
      </div>
    </BaseFrame>
    <div class="bottomFix">
      <div class="pharmacistInfo">
        <label>药师复核:</label>
        <lk-input class="mr8"  placeholder="药师账号" v-model="login.account"></lk-input>
        <lk-input  class="input-password" type='text' placeholder="密码"  v-model="login.password"></lk-input>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import BaseFrame from '../../components/frame/NewBaseFrame';
import DtpTable from '../../components/DtpTable';
import goods from '../../services/goods';
import utils from '../../libs/utils';
import DtpInputNumber from '../../components/DtpInputNumber';
import unpack from '../../services/unpack';
import user from '../../services/user';

export default {
  components: {
    BaseFrame, DtpTable,
  },
  data() {
    return {
      token: '',
      ready: false,
      unitArr: [],
      nameMix: '',
      dropdownVisible: false,
      options: [],
      selectLoading: false,
      login: {
        account: '',
        password: ''
      },
      columns: [
        {
          title: '商品编码', key: 'drugSerialCode', minWidth: 116, tooltip: true,
        },
        {
          title: '通用名', key: 'approvedDrugNames', minWidth: 116, tooltip: true,
        },
        {
          title: '规格', key: 'specifications', minWidth: 116, tooltip: true,
        },
        {
          title: '生产厂家', key: 'manufacturer', minWidth: 116, tooltip: true,
        },
        {
          title: '批号', key: 'goodsBatchNumber', minWidth: 116, tooltip: true,
        },
        {
          title: '包装单位', key: 'drugMiniPackageUnitString', minWidth: 116, tooltip: true,
        },
        {
          title: '原数量',
          key: 'originNum',
          minWidth: 116,
          tooltip: true,
          fixed: 'right',
          render: (h, params) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                if (value > params.row.stockNum) {
                  this.$Message.error('不可超库存拆零');
                }
                this.tableData[params.index].originNum = value;
              },
            },
            props: {
              value: params.row.originNum ? params.row.originNum : 1,
              min: 0,
              max: params.row.stockNum,
              precision: 2,
              placeholder: '请输入',
            },
          }),
        },
        {
          title: '拆零单位',
          key: 'unpackMinPkgUnit',
          minWidth: 116,
          tooltip: true,
          fixed: 'right',
          render: (h, params) => {
            const optionArr = [];
            this.unitArr.forEach((item) => {
              optionArr.push(h('lk-option', {
                props: {
                  value: item.dictionaryIndex,
                },
              }, item.dictionaryName));
            });
            return h('lk-select',
              {
                props: {
                  value: params.row.unpackMinPkgUnit,
                  transfer: true,
                },
                on: {
                  'on-change': (value) => {
                    this.tableData[params.index].unpackMinPkgUnit = value;
                  },
                },
              }, optionArr);
          },
        },
        {
          title: '拆零后数量',
          key: 'unpackNum',
          minWidth: 116,
          tooltip: true,
          fixed: 'right',
          render: (h, params) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.tableData[params.index].unpackNum = value;
              },
            },
            props: {
              value: params.row.unpackNum ? params.row.unpackNum : null,
              min: 0,
              precision: 0,
              placeholder: '请输入',
            },
          }),
        },
        {
          title: '拆零后单价',
          key: 'unpackRetailPrice',
          minWidth: 116,
          tooltip: true,
          fixed: 'right',
          render: (h, params) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.tableData[params.index].unpackRetailPrice = value;
              },
            },
            props: {
              value: params.row.unpackRetailPrice ? params.row.unpackRetailPrice : null,
              min: 0,
              precision: 2,
              placeholder: '请输入',
            },
          }),
        },
        {
          title: '操作',
          key: 'action',
          minWidth: 116,
          fixed: 'right',
          render: (h, params) => h('lk-button', {
            props: {
              type: 'text',
              size: 'small',
            },
            on: {
              click: () => {
                this.tableData.splice(params.index, 1);
              },
            },
          }, '删除'),
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    this.getUnitArr();
  },
  computed: {
    selectIdList() {
      const selectIdList = [];
      this.tableData.forEach((item) => {
        selectIdList.push(item.id);
      });
      return selectIdList;
    },
  },
  methods: {
    getToken() {
        const { account, password } = this.login;
        if(!(account && password)) {
            this.$Message.error('请输入药师账号和密码');
            return false;
        }
        this.token = '';
        user.loginToken(this.login).then((res) => {
            if (res.data.status === 200) {
              this.token = res.data.data;
              this.onSubmit();
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });  
    },
    getUnitArr() {
      this.$store.commit('setDisableLoading', true);
      goods.GoodsDictionary({ dictionaryTypeEnum: 3 }).then((res) => {
        if (res.data.status === 200) {
          res.data.data.forEach((item) => {
            if (item.dictionaryType === 3) {
              this.unitArr.push(item);
            }
          });
          this.ready = true;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // onInputChange(isFocus) {
    // eslint-disable-next-line func-names
    onInputChange: _.debounce(function (isFocus) {
      if (isFocus) {
        this.dropdownVisible = true;
      }
      if (this.nameMix) {
        const data = {
          nameMix: this.nameMix,
        };
        this.$store.commit('setDisableLoading', true);
        unpack.getUnpackableGoodsList(data).then((res) => {
          if (res.data.status === 200) {
            this.options = [];
            const list = res.data.data;
            if (res.data.data && res.data.data.length && this.nameMix) {
              if (list.length) {
                list.forEach((item) => {
                  if (item.goodsInfoVo) {
                    item.approvedDrugName = item.goodsInfoVo.approvedDrugName;
                    item.spec = item.goodsInfoVo.spec;
                    item.drugMiniPackageUnitString = item.goodsInfoVo.drugMiniPackageUnitString;
                    item.producer = item.goodsInfoVo.producer;
                  }
                  if (item.inventoryInfo) {
                    item.goodsBatchNumber = item.inventoryInfo.goodsBatchNumber;
                    item.goodsExpiryDate = utils.exchangeTime(item.inventoryInfo.goodsExpiryDate);
                    item.stockNum = item.inventoryInfo.stockNum;
                  }

                  if (item.inventoryInfo && !this.selectIdList.includes(item.inventoryInfo.id)) {
                    this.options.push(item);
                  }
                });
              }
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else {
        this.options = [];
        this.dropdownVisible = false;
      }
    }, 500),
    onDropDownclick(name) {
      if (this.selectLoading || name === 'title') {
        this.selectLoading = false;
        this.dropdownVisible = false;
        this.$nextTick(() => {
          this.$refs.dropdown.currentVisible = false; // 规避iview组件不能驱动内部参数问题
        });
      } else {
        this.dropdownVisible = true;
        this.selectLoading = true;
        if (!Number.isNaN(name)) {
          this.selected(name);
          this.$nextTick(() => {
            this.dropdownVisible = false;
          });
        }
        setTimeout(() => {
          this.selectLoading = false;
        }, 500);
      }
    },
    inputBlur() {
      this.$nextTick(() => {
        this.dropdownVisible = false;
      });
    },
    selected(name) {
      this.dropdownVisible = false;
      if (this.tableData.length >= 10) {
        this.$Message.error('每次最多支持10种商品拆零');
        return;
      }
      const tableItem = utils.deepClone(this.options[name].inventoryInfo);
      tableItem.drugMiniPackageUnitString = this.options[name].drugMiniPackageUnitString;
      tableItem.inventoryNum = this.options[name].inventoryNum;
      tableItem.originNum = 1;
      tableItem.unpackNum = 0;
      tableItem.unpackMinPkgUnit = '';
      tableItem.unpackRetailPrice = '';
      this.tableData.push(tableItem);
    },
    onBtnClick(name) {
      if (name === 'cancel') {
        this.onCancel();
      } else if (name === 'submit') {
        this.getToken();
      }
    },
    onCancel() {
      this.$router.push({ name: 'unpackList' });
    },
    // todo empty
    onSubmit() {
      const inventoryUnpackList = [];
      let isEmpty = true;
      if (!this.tableData.length) {
        this.$Message.error('未添加拆零商品不可提交');
        return;
      }
      this.tableData.forEach((item) => {
        const unpackItem = {};
        if (!(item.originNum > 0 && item.unpackNum && item.unpackMinPkgUnit && item.unpackRetailPrice)) {
          isEmpty = false;
        }
        unpackItem.goodsStoreId = item.goodsStoreId;
        unpackItem.originInventoryId = item.id;
        unpackItem.originNum = item.originNum;
        unpackItem.unpackNum = item.unpackNum;
        unpackItem.unpackMinPkgUnit = item.unpackMinPkgUnit;
        unpackItem.unpackRetailPrice = item.unpackRetailPrice;
        inventoryUnpackList.push(unpackItem);
      });
      if (!isEmpty) {
        this.$Message.error('请填写完整信息');
        return;
      }
      unpack.updateUnpackList(this.token, { inventoryUnpackList }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          this.$router.push({ name: 'unpackList' });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
};
</script>
<style lang="less">
.unpack-add{
  .unpacktable-index{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .unpacktable{
    margin-top: 10px;
  }
  .ivu-select-single .ivu-select-selection .ivu-select-placeholder{
    color: #515a6e;
  }
  .orange-words{
    color: #FF4D07;
  }
  .expir-card{
    margin-top: 12px;
  }
  .unpack-card{
    .ivu-card-body{
      position: relative;
    }
  }
  .unpack-input{
    width:300px
  }
  .unpack-dropdown{
  width: 800px;
  margin-left: 20px;
}
.searchList{
  max-height: 300px;
  overflow: auto;
}
.selected{
  background: #f8f8f8
}
.noTitle{
  .noThing{
    height: 36px;
    line-height: 36px;
    padding-left: 16px;
    color: rgba(0, 0, 0, 0.25)
  }
}
.options{
  display: flex;
  align-items: left;
  font-size: 12px;
  >span{
    width: 30%;
    text-align: left;
    word-wrap: none;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  >span:nth-child(2){
    width: 180px;
  }
  >span:nth-child(3){
    width: 80px;
  }
  .textOver{
    width: 100%;
    text-align: center;
    word-wrap: none;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
}
.bottomFix{
  background: #fff;
  position: fixed;
  padding: 0 38px;
  bottom:0;
  width: calc(~'100% - 220px') ;
  border-top: 1px solid #eee;
  height: 60px;
  z-index: 10;
  box-shadow: 0 0 8px #eee;
  .btns{
    height: 60px;
    line-height: 60px
  }
  .pharmacistInfo{
    float: left;
    display: flex;
    align-items: center;
     height: 60px;
    line-height: 60px;
    label{
      width: 160px;

    }
    label:before{
     content: '*';
      color: red;
      margin-right: 4px
    }
  }

}
</style>
